import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import "../style/home.css";

function Home() {
  const navigate = useNavigate();

  const [wings, setWings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [flats, setFlats] = useState([]);

  const [selectedWing, setSelectedWing] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [selectedFlat, setSelectedFlat] = useState("");
  const [previousReading, setPreviousReading] = useState("");
  const [currentReading, setCurrentReading] = useState("");
  const [difference, setDifference] = useState("");
  const [uploaderName, setUploaderName] = useState("");
  const [uploaderContact, setUploaderContact] = useState("");
  const [billFile, setBillFile] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isHintOpen, setIsHintOpen] = useState(false);
  const [uploading, setupLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    const fetchWings = async () => {
      try {
        const response = await axios.get(`https://api.lr.payplatter.in/api/wings`);
        setWings(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching wings:", error);
        setError("Failed to load wings");
        setLoading(false);
      }
    };
    fetchWings();
  }, []);

  // Fetch Floors based on selected Wing
  useEffect(() => {
    if (!selectedWing) {
      setFloors([]);
      setSelectedFloor("");
      setFlats([]);
      setSelectedFlat("");
      return;
    }

    const fetchFloors = async () => {
      try {
        const response = await axios.get(`https://api.lr.payplatter.in/api/floors/wing/${selectedWing}`);
        setFloors(response.data);
      } catch (error) {
        console.error("Error fetching floors:", error);
        setFloors([]);
      }
    };

    fetchFloors();
  }, [selectedWing]);

  // Fetch Flats based on selected Floor
  useEffect(() => {
    if (!selectedFloor) {
      setFlats([]);
      setSelectedFlat("");
      return;
    }

    const fetchFlats = async () => {
      try {
        const response = await axios.get(`https://api.lr.payplatter.in/api/flats/floor/${selectedFloor}`);
        setFlats(response.data);
      } catch (error) {
        console.error("Error fetching flats:", error);
        setFlats([]);
      }
    };

    fetchFlats();
  }, [selectedFloor]);

  useEffect(() => {
    if (!selectedFlat) {
      setPreviousReading("");
      return;
    }

    const fetchPreviousReading = async () => {
      try {
        const response = await axios.get(`https://api.lr.payplatter.in/api/meter-readings/${selectedFlat}/previous`);
        // console.log(response.data);
        // console.log('fniengrghrigrhgrgr');
        setPreviousReading(parseFloat(response.data.toString()) || "0.0");
      } catch (error) {
        console.error("Error fetching previous reading:", error);
        setPreviousReading("");
      }
    };

    fetchPreviousReading();
  }, [selectedFlat]);

  const handleWingChange = (e) => {
    setSelectedWing(e.target.value);
    setSelectedFloor("");
    setSelectedFlat("");
  };

  const handleFloorChange = (e) => {
    setSelectedFloor(e.target.value);
    setSelectedFlat("");
  };

  const handleFlatChange = (e) => {
    setSelectedFlat(e.target.value);
  };

  const handleProceed = () => {
    if (!selectedWing) {
      alert("Please select Wing");
      return;
    }

    else if (!selectedFloor) {
      alert("Please select Floor");
      return;
    }

    else if (!selectedFlat) {
      alert("Please select Flat No.");
      return;
    }

    // Generate dummy previous reading
    // const prevReading = Math.floor(Math.random() * 900) + 100; // Between 100 - 1000
    // setPreviousReading(prevReading);

    setShowForm(true);
  };

  const handleCurrentReadingChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
    value = value.slice(0, 5); // Limit to 5 digits
    setCurrentReading(value);
    setDifference(value ? parseFloat(value) - previousReading : "");
  };

  const handleBlur = () => {
    let value = currentReading;
    while (value.length < 5) {
      value = "0" + value; // Add leading zeros only when focus is lost
    }
    setCurrentReading(value);
  };


  const handleUploaderContactChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setUploaderContact(value);
    }
  };

  const handleUploaderNameChange = (e) => {
    const value = e.target.value;
    const filteredValue = value.replace(/[^A-Za-z]/g, " "); // Remove non-alphabet characters
    setUploaderName(filteredValue);
  };


  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const fileType = file.type;
      const fileSizeMB = file.size / 1024 / 1024; // Convert to MB (1024 bytes = 1KB, 1024 KB = 1MB)

      // Validate file type and size
      if ((fileType === "image/jpeg" || fileType === "image/png") && fileSizeMB <= 6) {
        setBillFile(file); // Set the file if valid

        // Create a preview of the selected image
        const fileReader = new FileReader();
        fileReader.onloadend = () => {
          setImagePreview(fileReader.result); // Set image preview as the base64 encoded string
        };
        fileReader.readAsDataURL(file); // Read the file as a Data URL
      } else {
        alert("Please upload a JPG or PNG file under 6MB.");
        e.target.value = ""; // Reset file input
        setBillFile(null); // Clear the file state
        setImagePreview(null); // Clear the preview
      }
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };



  const selectedWingName = wings.find(wing => wing.id == selectedWing);
  const selectedflatNo = flats.find(flat => flat.id == selectedFlat);

  const handleSubmit = async () => {
    if (!currentReading) {
      alert("Please enter current reading");
      return;
    } else if (!uploaderName) {
      alert("Please enter uploader name");
      return;
    } else if (uploaderContact.length !== 10) {
      alert("Please enter uploader contact ");
      return;
    } else if (!billFile) {
      alert("Please upload meter image");
      return;
    }

    setupLoading(true); // Disable button and show loading state

    const formData = new FormData();
    formData.append("wingId", selectedWing);
    formData.append("flatId", selectedFlat);
    formData.append("previousReading", previousReading);
    formData.append("currentReading", currentReading);
    formData.append("uploaderName", uploaderName);
    formData.append("uploaderContact", uploaderContact);
    formData.append("file", billFile);

    console.log(selectedWing);
    console.log(selectedflatNo.flatNo);
    console.log(currentReading);
    console.log(uploaderName);
    console.log(uploaderContact);

    try {
      const response = await axios.post(
        `https://api.lr.payplatter.in/api/meter-readings/add`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200) {
        alert("File uploaded successfully!");
        navigate("/confirmation", {
          state: {
            wing: selectedWingName.name,
            flat: selectedWingName.name + "-" + selectedflatNo.flatNo,
            mobileNumber: uploaderContact,
            name: uploaderName,
            previousReading,
            currentReading,
            waterUsage: difference,
            billFileName: billFile.name,
          },
        });
      } else {
        alert("Failed to upload file. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred while submitting. Please try again.");
    } finally {
      setupLoading(false); // Re-enable button after request is complete
    }
  };

  // PWA Install
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the PWA install prompt');
        } else {
          console.log('User dismissed the PWA install prompt');
        }
        // Clear the deferredPrompt after installation
        setDeferredPrompt(null);
        setIsInstallable(false);
      });
    }
  };

  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).replace(",", ""); // Remove comma if any

    setCurrentDate(formattedDate);
  }, []);


  return (
    <div className="home-container">
      <nav className="navbars">
        <div className="logo">
          {/* 💧  */}
          {isInstallable && (
            <button
              id="install-button"
              onClick={handleInstall}
              className="login-btn"
              style={{ padding: "12px 5px", width: "150px", background: "green" }}
            >
              <FaDownload /> Install PWA
            </button>
          )}</div>
        <h2 className="specials">Life Republic 7 Avenue Co-op Housing Society</h2>
      </nav>

      <div className="contents">
        <div className="text-content">
          <h2 className="special">Upload Water Meter Reading</h2>
          <div className="form-group">
            <span className="form-labels">Today's Date : {currentDate}</span>
          </div>

          {/* Wing Dropdown */}
          {!showForm && (
            <div className="form-group">
              <label className="form-label">Building:</label>
              {loading ? (
                <p>Loading Buildings...</p>
              ) : error ? (
                <p style={{ color: "red" }}>{error}</p>
              ) : (
                <select className="dropdown" value={selectedWing} onChange={handleWingChange} disabled={showForm}>
                  <option value="">Select Building</option>
                  {wings.map((wing) => (
                    <option key={wing.id} value={wing.id}>
                      {wing.name}
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}

          {/* Floor Dropdown */}
          {!showForm && (
            <div className="form-group">
              <label className="form-label">Floor:</label>
              <select className="dropdown custom-dropdown" value={selectedFloor} onChange={handleFloorChange} disabled={showForm}>
                <option value="">Select Floor</option>
                {floors.map((floor) => (
                  <option key={floor.id} value={floor.id}>
                    {floor.floorNo}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Flat Dropdown */}
          <div className="form-group">
            <label className="form-label">Flat No.:</label>
            <select className="dropdown" value={selectedFlat} onChange={handleFlatChange} disabled={showForm}>
              <option value="">Select Flat</option>
              {flats.map((flat) => (
                <option key={flat.id} value={flat.id}>
                  {selectedWingName.name + " - " + flat.flatNo}
                </option>
              ))}
            </select>
          </div>

          {/* Proceed Button */}
          {!showForm && (
            <button className="fetch-btn" onClick={handleProceed}>
              Proceed
            </button>
          )}

          {showForm && (
            <>
              <div className="form-group">
                <label className="form-label">Enter Current Reading:</label>
                {/* <input type="number" className="input-box" value={currentReading} onChange={handleCurrentReadingChange} /> */}
                <input
                  type="text"
                  className="input-box"
                  value={currentReading}
                  onChange={handleCurrentReadingChange}
                  onBlur={handleBlur} // Add leading zeros when the input loses focus
                  maxLength="5"
                  placeholder="Enter reading (5 digits)"
                />
              </div>

              <a
                className="hint"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsHintOpen(true);
                }}
                style={{ display: "block", marginBottom: "10px", color: "blue", cursor: "pointer" }}
              >
                Click For Help
              </a>

              {isHintOpen && (
                <div className="modal-overlay" onClick={() => setIsHintOpen(false)}>
                  <div className="modal-contents" onClick={(e) => e.stopPropagation()}>
                    <span className="close" onClick={() => setIsHintOpen(false)}>&times;</span>
                    <h2></h2>
                    <p style={{
                      marginTop: '10%'
                    }}>
                      Sample current reading is highlighted in the image below. Please locate the corresponding actual reading in your meter and enter in the provided field.
                      <p style={{
                        color: 'blue',
                        fontSize: '18px',
                        fontWeight: 'bold'
                      }}>Important: Enter only the numbers ( 5 digits ) written in black. Ignore the number written in red.</p>
                    </p>
                    <img
                      src="../assets/4.jpg"
                      alt="Meter Reading Guide"
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              )}
              <div className="form-group" style={{ margin: '20px 0' }}>
                <div className="upload-container" style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
                  <button
                    type="button"
                    onClick={handleButtonClick}
                    style={{
                      backgroundColor: 'white',
                      color: '#007BFF', // Blue text color
                      border: '2px solid #007BFF', // Blue border
                      padding: '12px 24px',
                      fontSize: '16px',
                      cursor: 'pointer',
                      borderRadius: '5px',
                      fontWeight: '600',
                      width: '100%',
                      textAlign: 'center',
                      transition: 'all 0.3s ease-in-out',
                      outline: 'none',
                    }}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                  >
                    {billFile ? billFile.name : 'Upload Meter Image'}
                  </button>
                  <p
                    className="file-size-info"
                    style={{
                      fontSize: '14px',
                      color: '#888',
                      marginTop: '8px',
                    }}
                  >
                    Max file size allowed: 6MB*
                  </p>
                </div>
                <input
                  type="file"
                  ref={fileInputRef}
                  accept="image/jpeg, image/png"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />

                {/* Image preview */}
                {imagePreview && (
                  <div style={{ marginTop: '20px' }}>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '300px', // Adjust the size as needed
                        borderRadius: '5px',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="form-group">
                <label className="form-label">Uploader Name:</label>
                <input
                  type="text"
                  className="input-box"
                  value={uploaderName}
                  onChange={handleUploaderNameChange}
                />
              </div>

              <div className="form-group">
                <label className="form-label">Uploader Contact Number:</label>
                <input type="text" className="input-box" value={uploaderContact} onChange={handleUploaderContactChange} />
              </div>
              <div className="confirmation-boxxx">
                <p className="para">1. Avoid average billing by submitting meter reading</p>
                <div className="paara">
                  <p>
                    <span style={{ color: "green" }}>2. Upload by 10th of every month to get ₹10 discount</span>
                    <span style={{ color: "black", fontSize: "10px" }}>* (subject to AGM approval)</span>
                  </p>
                </div>
              </div>
              <button className="confirm-btns" onClick={handleSubmit} disabled={uploading}>
                {uploading ? "Uploading..." : "Submit"}
              </button>
            </>
          )}
        </div>
        <div className="footers">
          <p>powered by @Dexpert Systems</p>
        </div>
      </div>

    </div>

  );
}

export default Home;